import { createStore } from "effector";
import connectLocalStorage from "effector-localstorage";
import { SessionContext } from "@type/session/session.types";
import { sessionContextEvent, setOrigin } from "@state/session/SessionEvents";

const sessionLocalStorage = connectLocalStorage("sessionStore").onError((err) =>
  console.log(err)
);

export const sessionStore = createStore<SessionContext | null>(
  sessionLocalStorage.init(0)
);

sessionStore
  .on(sessionContextEvent, (state, payload) => {
    return payload === undefined
      ? null
      : {
          ...payload,
        };
  })
  .on<string | undefined>(
    setOrigin,
    (state, payload: string | undefined): SessionContext => {
      return {
        ...state,
        origin: payload,
      };
    }
  );

sessionStore.watch(sessionLocalStorage);
